export default "__VITE_ASSET__CIfaE2Zy__"